import { NgModule } from '@angular/core';
import { MomentModule } from 'ngx-moment';
import { CommonModule } from '@angular/common';
import { PipesModule } from './../shared/pipes/pipes.module';
import { RouterModule } from '@angular/router';
import { HorizonsService } from './shared/horizons.service';
import { HorizonsComponent } from './horizons.component';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MomentModule,
    PipesModule
  ],
  declarations: [
    HorizonsComponent
  ],
  providers:[
    HorizonsService
  ]
})
export class HorizonsModule { }
